export const timeFormat = (video_length: string | undefined): string => {
  const before = video_length?.split(':').reverse()
  const after: string[] = []
  for (let i = 0; i < 3; i++) {
    const sliceTime = Math.ceil(Number(before?.[i])) ? Math.ceil(Number(before?.[i]))?.toString() : '00'
    after.push(!!sliceTime?.length ? (sliceTime?.length >= 2 ? sliceTime : sliceTime.padStart(2, '0')) : '00')
  }
  return after?.reverse().join(':')
}

export const formatDate = (text: string | number | Date | undefined): string => {
  const date = new Date(text as string | number | Date)
  if (isNaN(date.getTime())) return '-'
  return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()}`
}

export const formatDateTime = (text: string | number | Date | undefined): string => {
  const date = new Date(text as string | number | Date)
  if (isNaN(date.getTime())) return '-'
  return (
    `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate()} ` +
    `${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date
      .getSeconds()
      .toString()
      .padStart(2, '0')}`
  )
}
